import React, { useContext, useEffect, useState } from 'react';
import Esqueceu from '../Componentes/Esqueceu';
import LogoHeader from '../Componentes/LogoHeader';
import ImagemDiv from '../Componentes/ImagemDiv';
import { useNavigate, Link } from 'react-router-dom';
import TextInput from '../Componentes/TextInput';
import { StoreContexto } from '../Contexto/Provider';
import Cookies from 'js-cookie';
import { apiService } from '../Services/ApiService';
import '../Estilos/Home.css';

function Home() {
  const [controleValor, setControle] = useState('');
  const [senhaValor, setSenha] = useState('');
  const [erroLogin, setErroLogin] = useState(false);
  const { setAuth, KeepOn, setKeepOn, setPerfilUser } = useContext(StoreContexto);
  const [fieldFilled, setFieldFilled] = useState(false);
  const [updatedPage, setUpdatedPage] = useState(false);

  const navigate = useNavigate();
  const { post } = apiService();

  useEffect(() => {
    const fieldFilled = controleValor.trim() !== '' && senhaValor.trim() !== '';
    setFieldFilled(fieldFilled);
  }, [controleValor, senhaValor]);

  useEffect(() => {
    if (!updatedPage) {
      setAuth({ token: '', idLogin: -1, controleSalvo: '', nomeSalvo: '' });
      setKeepOn('session');
      Cookies.remove('KeepOn');
      localStorage.clear();
      setUpdatedPage(true);
    }
  }, [updatedPage]);

  const loginNavigate = async () => {
    try {
      const data = await post('auth/login', {
        control: controleValor,
        password: senhaValor,
        rememberMe: KeepOn === 'local',
      });

      if (data.token) {
        setErroLogin(false);
        setAuth({
          token: data.token,
          idLogin: data.user.id,
          controleSalvo: data.user.control,
          nomeSalvo: data.user.name,
          perfilSalvo: data.user.role,
        });
        navigate('/welcome');
      } else {
        setToken('');
        setErroLogin(true);
      }
    } catch (error) {
      setErroLogin(true);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        height: '100vh',
        minHeight: 720,
      }}
    >
      <div className="CorpoLogin">
        <div className="AreaLogin">
          <div className="AreaLoginInterna">
            <LogoHeader />
            <h3
              id="TituloLogin"
              style={{ textAlign: 'center', fontFamily: 'Montserrat', fontSize: 20 }}
            >
              LOGIN
            </h3>
            <TextInput
              titulo="Controle"
              tipo="text"
              placeholder="Insira o Controle"
              onUpdate={(txt) => {
                setControle(txt);
              }}
              keyTrigger
              onEnter={() => loginNavigate()}
              padrao={controleValor}
            />
            <TextInput
              id="senha"
              titulo="Senha"
              tipo="password"
              password
              placeholder="Insira a Senha"
              keyTrigger
              onUpdate={(txt) => setSenha(txt)}
              erro={erroLogin}
              erroTexto="Usuário e/ou senha incorretos"
              onEnter={() => loginNavigate()}
              padrao={senhaValor}
            />
            <Esqueceu />
            <button
              id="BotaoLogin"
              className="BotaoLogin"
              onClick={() => {
                loginNavigate();
              }}
              disabled={!fieldFilled}
            >
              Entrar
            </button>
            <div style={{ marginTop: 30 }}>
              <Link to="/DashboardView">
                <u
                  style={{
                    fontSize: 16,
                    color: '#545e6b',
                    fontFamily: 'montserrat',
                  }}
                >
                  Visualizar dashboard
                </u>
              </Link>
            </div>
          </div>
        </div>
        <ImagemDiv />
      </div>
    </div>
  );
}

export default Home;
